module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar",
    class: {
      '-hidden': !_vm.showSidebar
    }
  }, [_c('nav', {
    staticClass: "sidebar-menu"
  }, [_c('span', {
    staticClass: "header"
  }, [_vm._v("Acadêmico")]), _vm._v(" "), (_vm.professor) ? _c('a', {
    attrs: {
      "href": "https://webdiario.urcamp.edu.br",
      "target": "_blank"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Webdiário")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.grade-horarios'
    },
    attrs: {
      "to": {
        name: 'academico.grade-horarios'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Grade de Horários")])]), _vm._v(" "), (!_vm.soEnsinoBasico) ? _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.frequencia-notas'
    },
    attrs: {
      "to": {
        name: 'academico.frequencia-notas'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fab fa-firstdraft"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Frequência e Notas")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.boletins-pareceres'
    },
    attrs: {
      "to": {
        name: 'academico.boletins-pareceres'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Boletins e Pareceres")])]), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.atestado-matricula'
    },
    attrs: {
      "to": {
        name: 'academico.atestado-matricula'
      },
      "data-intro": "Gerar o seu atestado de matrícula do curso",
      "data-step": "3"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-file-pdf"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Atestado de Matrícula")])]), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.atestado-trancamento'
    },
    attrs: {
      "to": {
        name: 'academico.atestado-trancamento'
      },
      "data-intro": "Gerar o seu atestado de vínculo com trancamento",
      "data-step": "3"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-file-pdf"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Atestado de Trancamento")])]), _vm._v(" "), (!_vm.soEnsinoBasico) ? _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'academico.disciplinas-cursadas'
    },
    attrs: {
      "to": {
        name: 'academico.disciplinas-cursadas'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "far fa-file-alt"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Disciplinas Cursadas")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v("Financeiro")]), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'financeiro.minhas-cobrancas'
    },
    attrs: {
      "to": {
        name: 'financeiro.minhas-cobrancas'
      },
      "data-intro": "Suas cobranças e boletos junto a URCAMP",
      "data-step": "4"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-barcode"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Minhas Cobranças")])]), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'financeiro.demonstrativo'
    },
    attrs: {
      "to": {
        name: 'financeiro.demonstrativo'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-file-alt"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Demonstrativo Anual")])]), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v("Serviços")]), _vm._v(" "), (_vm.exibeProtocolo()) ? _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'protocolo'
    },
    attrs: {
      "to": {
        name: 'protocolo'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-tasks"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Protocolos")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleBibliotecas
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Bibliotecas Virtuais")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "bibliotecas",
    class: {
      '-mostrar': _vm.mostrarBibliotecas
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.abrirBiblioteca('bminhabiblioteca')
      }
    }
  }, [_vm._v("Minha Biblioteca")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "header"
  }, [_vm._v("Pessoal")]), _vm._v(" "), _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'minha-conta.inicial'
    },
    attrs: {
      "to": {
        name: 'minha-conta.inicial'
      },
      "data-intro": "Edite seus dados pessoais, avatar, email acadêmico, permissões de notificação...",
      "data-step": "5"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "far fa-user-circle"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Minha Conta")])]), _vm._v(" "), (false) ? _c('router-link', {
    class: {
      '-active': _vm.menuAtivo === 'meu-drive'
    },
    attrs: {
      "to": {
        name: 'meu-drive'
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fab fa-google-drive"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Meu Drive")])]) : _vm._e(), _vm._v(" "), (false) ? _c('a', {
    attrs: {
      "href": "https://accounts.google.com/signin/v2/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F&service=mail&hd=urcamp.edu.br&sacu=1&flowName=GlifWebSignIn&flowEntry=AddSession&hl=pt",
      "target": "_blank"
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Meu Email do Google")])]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalContato = true
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Fale Conosco")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sair")])])], 1), _vm._v(" "), _c('formulario-contato', {
    attrs: {
      "mostrar": _vm.mostrarModalContato
    },
    on: {
      "update:mostrar": function($event) {
        _vm.mostrarModalContato = $event
      }
    }
  }), _vm._v(" "), (_vm.versaoAtual) ? _c('div', {
    staticClass: "app-version"
  }, [_vm._v("\n      Versão " + _vm._s(_vm.versaoAtual) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-chalkboard-teacher"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://biblioteca.urcamp.edu.br",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-book"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Biblioteca")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon icon-right"
  }, [_c('i', {
    staticClass: "fas fa-chevron-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://ouvidoria.urcamp.edu.br/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-phone-square"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Ouvidoria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://inscricoes.eventos.urcamp.edu.br",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fab fa-connectdevelop"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Inscrição/Submissão de trabalhos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://eventos.urcamp.edu.br",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fab fa-connectdevelop"
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sistema de Eventos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "far fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sidebar-icon"
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-464e5e27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/Sidebar.vue
// module id = 537
// module chunks = 2